// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Wwj8","term":"_5wDVn"};


//////////////////
// WEBPACK FOOTER
// ./app/components/no-member-results/no-member-results.scss
// module id = 1656
// module chunks = 0